import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAppInsights } from '../utils/appInsights';

/** Tracks page views for SPA navigation (required when using HashRouter). */
export default function AppInsightsPageViews() {
  const location = useLocation();

  useEffect(() => {
    const ai = getAppInsights();
    if (!ai) return;

    const path = `${location.pathname}${location.search}${location.hash}`;
    ai.trackPageView({
      name: path,
      uri: window.location.href,
    });
  }, [location]);

  return null;
}
